import React, { useContext, useMemo } from 'react'

import { FilterVariant } from '@/components/shared/filters/filter-button'
import ProductionListContext, { ProductionListProvider } from '@/context/productions-list'

import DateFilter, { DateFilterProvider } from './components/date-filter'
import { DateFilterContextType } from './components/date-filter/contexts/date-filter/types'

type Props = {
    variant?: FilterVariant
    clearToOriginalRange?: boolean
    customDateContext?: React.Context<DateFilterContextType>
    footerButtonLabel?: string
    customLabel?: string
}

const DateFilterWrapper: React.FC<Props> = ({
    variant,
    clearToOriginalRange,
    customDateContext,
    footerButtonLabel,
    customLabel,
}) => {
    const {
        state: parentProductionListState,
        selectors: { params: parentParams, filterMappers: parentFilterMappers },
        dispatch: { onFilterChangeAction: parentOnFilterChangeAction },
    } = useContext(ProductionListContext)

    // We only care about the total count so request as little as possible
    // "pageSize: 1" is the minimum that is supported by catalog service
    const parentParamsWithOverrides = useMemo(() => ({ ...parentParams, page: 1, pageSize: 1 }), [parentParams])

    return (
        <ProductionListProvider
            initialParams={parentParamsWithOverrides}
            initialProps={parentProductionListState}
            updateUrlOnFilterChange={false}
            filterMappers={parentFilterMappers}
        >
            <DateFilterProvider
                parentOnFilterChangeAction={parentOnFilterChangeAction}
                clearToOriginalRange={clearToOriginalRange}
            >
                <DateFilter
                    variant={variant}
                    customDateContext={customDateContext}
                    footerButtonLabel={footerButtonLabel}
                    defaultFilterLabel={customLabel}
                />
            </DateFilterProvider>
        </ProductionListProvider>
    )
}

export default DateFilterWrapper
